// eslint-disable-next-line vue/max-len
export default () => Math.random().toString(36).slice(2, 15) + Math.random().toString(36).slice(2, 15);
